module.exports = __webpack_public_path__ + "images/124_320.jpg";